import { Domain } from "../model/model";

import chroma from "chroma-js";

export const flatten = (list) =>
  list.reduce((a, b) => a.concat(Array.isArray(b) ? flatten(b) : b), []);

export const move = (
  array: Array<any>,
  old_index: number,
  new_index: number
) => {
  if (new_index >= array.length) {
    let k = new_index - array.length + 1;
    while (k--) {
      array.push(null);
    }
  }
  array.splice(new_index, 0, array.splice(old_index, 1)[0]);
};

export const getbaseUrl = (): string => {
  const pathArray = window.location.href.split("/");
  const protocol = pathArray[0];
  const host = pathArray[2];
  return protocol + "//" + host;
};

export const baseUrl = (url: string): string => {
  const pathArray = url.split("/");
  const protocol = pathArray[0];
  const host = pathArray[2];
  return protocol + "//" + host;
};

export interface Dictionary<T> {
  [Key: string]: T;
}

export class DomainColors {
  domainId: string;
  subjectColors: Dictionary<string>;
}

export let domainColor: DomainColors = null;
export const getSubjectColor = (domainId: string, subjectCode: string) => {
  return domainColor ? domainColor.subjectColors[subjectCode] : "";
};

export const initColors = (domain: Domain) => {
  if (domain) {
    if (!domainColor || domain.id !== domainColor.domainId) {
      const colorScale = chroma
        .scale(["#1ACB83", "#00B6DE", "#E05DFF"])
        .mode("lch")
        .colors(domain.subjects.length);
      const subjectColors: Dictionary<string> = {};
      domain.subjects.forEach((subject, index) => {
        subjectColors[subject.code] = colorScale[index];
      });
      domainColor = { domainId: domain.id, subjectColors: subjectColors };
    }
  }
};

export const combine = <T>(list1: Array<T>, list2: Array<T>) => {
  if (list1) {
    if (list2) {
      return list1.concat(list2);
    }
    return list1;
  }
  return null;
};

export const getStateIcons = () => [
  {
    icon: "",
    url: "assets/statusicons/AwaitingUpdate.svg",
    color: "#D6D6D6",
    state: "AwaitingUpdate",
    text: "STATE_AWAIT",
    actiontext: "STATE_AWAIT_ACTION",
  },
  {
    icon: "",
    url: "assets/statusicons/Unassigned.svg",
    color: "#D6D6D6",
    state: "Unassigned",
    text: "STATE_UNASSIGNED",
    actiontext: "STATE_UNASSIGNED_ACTION",
  },
  {
    icon: "",
    url: "assets/statusicons/Assigned.svg",
    color: "#ffffff",
    state: "Assigned",
    text: "STATE_ASSIGNED",
    actiontext: "STATE_ASSIGNED_ACTION",
  },
  {
    icon: "",
    url: "assets/statusicons/TestStarted.svg",
    color: "#A0C7D8",
    state: "TestStarted",
    text: "STATE_STARTED",
    actiontext: "STATE_STARTED_ACTION",
  },
  {
    icon: "",
    url: "assets/statusicons/Failed.svg",
    color: "#C892AC",
    state: "Failed",
    text: "STATE_FAILED",
    actiontext: "STATE_FAILED_ACTION",
  },
  {
    icon: "",
    url: "assets/statusicons/Passed.svg",
    color: "#1ACB83",
    state: "Passed",
    text: "STATE_PASSED",
    actiontext: "STATE_PASSED_ACTION",
  },
  {
    icon: "",
    url: "assets/statusicons/PassedManually.svg",
    color: "#00B3FF",
    state: "PassedManually",
    text: "STATE_PASSED_MANUALLY",
    actiontext: "STATE_PASSED_MANUALLY_ACTION",
  },
  {
    icon: "",
    url: "assets/statusicons/FailedManually.svg",
    color: "#C892AC",
    state: "FailedManually",
    text: "STATE_FAILED_MANUALLY",
    actiontext: "STATE_FAILED_MANUALLY_ACTION",
  },
  {
    icon: "",
    url: "assets/statusicons/OfflineReady.svg",
    color: "#A0C7D8",
    state: "OfflineReady",
    text: "STATE_OFFLINE_READY",
    actiontext: "STATE_OFFLINE_READY_ACTION",
  },
];
